var styles = {
  "TotalUsageLimitTextField": "DiscountAppComponents-UsageLimitsCard__TotalUsageLimitTextField"
};

export { styles as default };
